// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2iZha","description":"PatientConsentPreview_description__2XQ1J"};